import { CommunicationService } from '@carboncopyco/mimesis-shared';
import { TourStepEngineIncomingMessageType } from '@carboncopyco/types';
import { scopedLogger, Scope } from '@carboncopyco/logger';
import { useDocumentVisibility } from 'ahooks';
import { useEffect } from 'react';
import usePrevious from '../usePrevious';

interface Props {
  activeTabId: number;
  playerIframe: HTMLIFrameElement;
}

const communicationService = new CommunicationService({
  ignoreDeviceContext: true,
});
const engineLogger = scopedLogger(Scope.TOUR_ENGINE);

export const useStopPlayingMedia = ({ activeTabId, playerIframe }: Props) => {
  const documentVisibility = useDocumentVisibility();

  const prevActiveTabId = usePrevious(activeTabId);

  const stopPlayingMedia = () => {
    communicationService.postMessage({
      message: {
        type: TourStepEngineIncomingMessageType.stopPlayingMedia,
      },
      targetWindow: playerIframe?.contentWindow,
    });
    engineLogger.info('Stopped playing media');
  };

  useEffect(() => {
    if (documentVisibility === 'hidden') {
      stopPlayingMedia();
    }
  }, [documentVisibility]);

  useEffect(() => {
    if (activeTabId !== prevActiveTabId) {
      stopPlayingMedia();
    }
  }, [prevActiveTabId, activeTabId]);
};
